export const statisticTabs = [
  {
    label: 'Contract Temp.',
    tooltip: 'Contract Templates',
    value: 'total_templates',
    count: 0,
    apiKey: 'total_templates',
  },
  {
    label: 'Riverus Temp.',
    tooltip: 'Riverus Templates',
    value: 'system_templates',
    count: 0,
    apiKey: 'system_templates',
  },
  {
    label: 'Support Temp.',
    tooltip: 'Support Templates',
    value: 'support_document_templates',
    count: 0,
    apiKey: 'support_document_templates',
  },
];

export const myStatisticTabs = [
  {
    label: 'Contract Temp.',
    tooltip: 'My contract Templates',
    value: 'my_templates',
    count: 0,
    apiKey: 'my_templates',
  },
  {
    label: 'Support Temp.',
    tooltip: 'My Support Templates',
    value: 'my_support_document_templates',
    count: 0,
    apiKey: 'my_support_document_templates',
  },
];

export const TemplateTableTabs = [
  { label: 'Contract Templates', value: 'template' },
  { label: 'Support Document Templates', value: 'support_doc_template' },
];

export const selectTypeDocument = [
  // { id: 1, name: 'Invoice' },
  // { id: 2, name: 'Purchase Order' },
  // { id: 3, name: 'Receipt' },
  // { id: 4, name: 'Correspondence' },
  // { id: 5, name: 'Approval/Licenses' },
  // { id: 6, name: 'Litigation Papers' },
  // { id: 7, name: 'GST / Trade Docs' },
  // { id: 8, name: 'Reports' },
  // { id: 9, name: 'Checklist' },
  { id: 10, name: 'Termination Letter/Agreement' },
  { id: 11, name: 'Renewal Letter/Agreement' },
];
